import axios from 'axios'
import moment from 'moment'
import AscentiaService from './ascentiaService'

const values = {
  removals: null,
}

const getters = {
  removals(removalsParams) {
    const startDate = moment(removalsParams.endDate)
      .subtract(3, 'months')
      .format('YYYY-MM-DD')
    const endDate = moment(removalsParams.endDate).format('YYYY-MM-DD')

    const url = `/Removal?tailNumber=${removalsParams.tail}&airline=${removalsParams.airline}&startDate=${startDate}&endDate=${endDate}`
    return axios.get(url)
  },

  removalsByTail(removalsParams) {
    const startDate = moment(removalsParams.startDate).format('YYYY-MM-DD')
    const endDate = moment(removalsParams.endDate).format('YYYY-MM-DD')

    const url = `/Removal?tailNumber=${removalsParams.tailName}&startDate=${startDate}&endDate=${endDate}`
    return axios.get(url)
  },
}

export default class RemovalService extends AscentiaService {
  get values() {
    return values
  }

  get getters() {
    return getters
  }
}
